"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = patchDialogServiceConnectorInline;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _pDefer = _interopRequireDefault(require("./external/p-defer")); // Patching a function to add pre-processing of arguments and post-processing of result.


function patchFunction(fn, pre, post) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    args = pre ? pre.apply(void 0, (0, _toConsumableArray2.default)(args)) : args;
    var result = fn.apply(void 0, (0, _toConsumableArray2.default)(args));
    return post ? post(result) : result;
  };
}

function patchDialogServiceConnectorInline(dialogServiceConnector) {
  // This function will patch DialogServiceConnector by modifying the object.
  // The patches are intended to fill-in features to make DialogServiceConnector object works like the full-fledged Recognizer object.
  var lastRecognitionDeferred;
  dialogServiceConnector.listenOnceAsync = patchFunction(dialogServiceConnector.listenOnceAsync.bind(dialogServiceConnector), function (resolve, reject) {
    lastRecognitionDeferred = (0, _pDefer.default)();

    for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    return [patchFunction(resolve, null, function (result) {
      lastRecognitionDeferred.resolve(result);
      return result;
    }), patchFunction(reject, null, function (error) {
      lastRecognitionDeferred.reject(error);
      return error;
    })].concat(args);
  }); // TODO: startContinuousRecognitionAsync is not working yet, use listenOnceAsync instead.

  dialogServiceConnector.startContinuousRecognitionAsync = function (resolve, reject) {
    dialogServiceConnector.listenOnceAsync(function () {// We will resolve the Promise in a setTimeout.
    }, function (err) {
      resolve = null;
      reject && reject(err);
    });
    setTimeout(function () {
      reject = null;
      resolve && resolve();
    }, 0);
  }; // TODO: stopContinuousRecognitionAsync is not working yet.
  //       We will leave out the implementation as falsy, Web Chat will disable the microphone button after start dictate.
  //       This will prevent user from aborting speech recognition.
  // dialogServiceConnector.stopContinuousRecognitionAsync = resolve => {
  // };


  return dialogServiceConnector;
}